// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.profile-section {
  padding: 60px 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 248, 248, 0.95) 100%);
  min-height: 100vh;
}

/* Profile Header */
.profile-header {
  background: white;
  border-radius: 16px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(212, 175, 55, 0.1);
}

.profile-avatar {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #d4af37;
  background: #f3f4f6;
}
.avatar-img.avatar-img-svg {
  object-fit: contain;
  padding: 8px;
}

.avatar-edit {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 36px;
  height: 36px;
  background: #d4af37;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0;
}
.avatar-edit input {
  display: none;
}
.avatar-edit:hover {
  transform: scale(1.1);
}
.avatar-edit.avatar-edit-disabled {
  opacity: 0.7;
  pointer-events: none;
}

.avatar-clear {
  position: absolute;
  top: 0;
  right: 0;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #b91c1c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}
.avatar-clear:hover {
  background: #991b1b;
}

.avatar-hint {
  max-width: 140px;
  margin-left: auto;
  margin-right: auto;
}

.profile-info {
  padding-left: 20px;
}

.name-container {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.profile-name {
  font-family: "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 24px;
  margin: 0;
  margin-right: 10px;
}

.verified-badge {
  background: rgba(212, 175, 55, 0.1);
  color: #d4af37;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
}
.verified-badge i {
  margin-right: 5px;
}

.contact-info p {
  margin-bottom: 5px;
  color: #666;
}
.contact-info p i {
  color: #d4af37;
  width: 20px;
  margin-right: 8px;
}

.profile-stats {
  display: flex;
  justify-content: space-around;
  background: rgba(212, 175, 55, 0.05);
  border-radius: 12px;
  padding: 15px;
}

.stat-item {
  text-align: center;
}
.stat-item .stat-value {
  display: block;
  font-size: 24px;
  font-weight: 500;
  color: #d4af37;
}
.stat-item .stat-label {
  font-size: 14px;
  color: #666;
}

/* Profile Tabs — custom classes (not Bootstrap nav-tabs) so borders don't jump */
.profile-tabs {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(212, 175, 55, 0.1);
}

.profile-tab-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  list-style: none;
  margin: 0 0 30px;
  padding: 0;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
}

.profile-tab-item {
  margin: 0;
  padding: 0;
}

.profile-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 42px;
  margin: 0;
  padding: 0 20px;
  border: 0;
  border-radius: 8px 8px 0 0;
  background: transparent;
  color: #666 !important;
  font: inherit;
  font-weight: 500;
  font-size: 15px;
  line-height: 1;
  text-decoration: none !important;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.profile-tab::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 0;
  height: 3px;
  border-radius: 2px 2px 0 0;
  background: transparent;
  pointer-events: none;
}
.profile-tab i {
  margin-right: 8px;
  color: #d4af37;
  flex-shrink: 0;
}
.profile-tab:hover:not(.active), .profile-tab:focus:not(.active) {
  background: rgba(0, 0, 0, 0.02);
  color: #666 !important;
}
.profile-tab.active {
  color: #d4af37 !important;
  background: rgba(212, 175, 55, 0.05);
}
.profile-tab.active::after {
  background: #d4af37;
}
.profile-tab:focus-visible {
  outline: 2px solid rgba(212, 175, 55, 0.45);
  outline-offset: -2px;
}

/* Listings Tab */
.add-listing-btn {
  margin-bottom: 20px;
  text-align: right;
}
.add-listing-btn .btn-primary {
  background: #d4af37;
  border-color: #d4af37;
}
.add-listing-btn .btn-primary:hover {
  background: rgb(177.7777777778, 144.8888888889, 38.2222222222);
  border-color: rgb(177.7777777778, 144.8888888889, 38.2222222222);
}
.add-listing-btn .btn-primary i {
  margin-right: 8px;
}

.listing-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease, border-color 0.3s ease, transform 0.3s ease;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}
.listing-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  border-color: rgba(212, 175, 55, 0.3);
}

.listing-image {
  position: relative;
  height: 180px;
}
.listing-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.listing-badges {
  position: absolute;
  top: 10px;
  right: 10px;
}
.listing-badges .badge {
  display: block;
  margin-bottom: 5px;
  padding: 5px 10px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
}
.listing-badges .badge-status {
  background: #666;
  color: white;
}
.listing-badges .badge-status[data-status=PENDING] {
  background: #c9a227;
}
.listing-badges .badge-status[data-status=REJECTED] {
  background: #c62828;
}
.listing-badges .badge-status[data-status=PUBLISHED] {
  background: #2e7d32;
}
.listing-badges .badge-status[data-status=DRAFT] {
  background: #616161;
}
.listing-badges .badge-featured {
  background: #d4af37;
  color: white;
}
.listing-badges .badge-new {
  background: #4CAF50;
  color: white;
}

.listing-content {
  padding: 15px;
}

.listing-flash {
  margin: 0 0 16px;
  padding: 10px 12px;
  border-radius: 8px;
}

.listing-flash-ok {
  background: #f1f8f2;
  color: #0f5132;
  border: 1px solid #b7dfc0;
}

.listing-flash-error {
  background: #fff5f5;
  color: #842029;
  border: 1px solid #f5c2c7;
}

.listing-rejection {
  font-size: 13px;
  color: #842029;
  margin: -8px 0 12px;
}
.listing-rejection.hint {
  color: #666;
}

.listing-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.listing-price {
  font-size: 18px;
  font-weight: 600;
  color: #d4af37;
  margin-bottom: 15px;
}

.listing-actions {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}
.listing-actions .btn {
  flex: 0 0 auto;
  margin: 0;
}
.listing-actions .btn i {
  margin-right: 5px;
}
.listing-actions .btn-outline-primary {
  color: #d4af37;
  border-color: #d4af37;
}
.listing-actions .btn-outline-primary:hover {
  background: #d4af37;
  color: white;
}

.empty-state {
  text-align: center;
  padding: 50px 0;
}

.empty-state-content {
  max-width: 400px;
  margin: 0 auto;
}
.empty-state-content i {
  font-size: 48px;
  color: #d4af37;
  margin-bottom: 20px;
}
.empty-state-content h3 {
  font-size: 20px;
  margin-bottom: 10px;
}
.empty-state-content p {
  color: #666;
  margin-bottom: 20px;
}

/* Reviews Tab */
.reviews-container {
  padding: 20px 0;
}

.review-summary {
  text-align: center;
  margin-bottom: 30px;
}

.overall-rating .rating-value {
  font-size: 48px;
  font-weight: 600;
  color: #d4af37;
  display: block;
  line-height: 1;
}
.overall-rating .stars {
  margin: 10px 0;
  color: #d4af37;
  font-size: 18px;
}
.overall-rating .rating-count {
  color: #666;
  font-size: 14px;
}

.review-item {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.reviewer-info {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.reviewer-info .reviewer-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 15px;
}
.reviewer-info h4 {
  font-size: 16px;
  margin: 0 0 5px;
}
.reviewer-info .stars {
  color: #d4af37;
  font-size: 14px;
  margin-bottom: 5px;
}
.reviewer-info .review-date {
  color: #999;
  font-size: 12px;
}

.review-text {
  color: #333;
  margin: 0;
}

/* About Tab */
.about-container {
  padding: 20px 0;
}

.about-section {
  margin-bottom: 30px;
}
.about-section h3 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
}
.about-section p {
  color: #666;
  line-height: 1.6;
}

.business-hours .day-hours {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.business-hours .day-hours:last-child {
  border-bottom: none;
}
.business-hours .day {
  font-weight: 500;
  color: #333;
}
.business-hours .hours {
  color: #666;
}

/* Settings Tab */
.settings-container {
  padding: 20px 0;
}

.form-section {
  margin-bottom: 30px;
}
.form-section h3 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.2);
}

.form-group {
  margin-bottom: 20px;
}
.form-group label {
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.shop-jumbo-preview {
  width: 100%;
  max-width: 480px;
  height: 120px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  border: 1px solid #e5e7eb;
}

/* Shopfront editor — matches Admin → Branding layout */
.shopfront-branding {
  max-width: 960px;
  margin: 0 auto;
  padding: 8px 0 48px;
}
.shopfront-branding .branding-header {
  margin-bottom: 24px;
}
.shopfront-branding .branding-header h1 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 8px;
  font-size: 1.75rem;
}
.shopfront-branding .branding-header p {
  margin: 0;
  color: rgba(0, 0, 0, 0.6);
}
.shopfront-branding .error-text {
  color: #b91c1c;
}
.shopfront-branding .success-text {
  color: #15803d;
}
.shopfront-branding .branding-identity {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}
@media (max-width: 720px) {
  .shopfront-branding .branding-identity {
    grid-template-columns: 1fr;
  }
}
.shopfront-branding .name-field,
.shopfront-branding .font-field {
  width: 100%;
}
.shopfront-branding .home-card {
  margin-bottom: 16px;
}
.shopfront-branding .home-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 16px;
}
.shopfront-branding .home-grid .full-width {
  grid-column: 1/-1;
}
.shopfront-branding .home-grid mat-form-field {
  width: 100%;
}
@media (max-width: 720px) {
  .shopfront-branding .home-grid {
    grid-template-columns: 1fr;
  }
}
.shopfront-branding .identity-preview {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
  padding: 10px 14px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  background: #fafafa;
}
.shopfront-branding .preview-name {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  color: #1a1a1a;
}
.shopfront-branding .branding-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.shopfront-branding .branding-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 16px;
}
.shopfront-branding .branding-card h2 {
  margin: 0 0 4px;
  font-size: 1.1rem;
}
.shopfront-branding .branding-card .hint {
  margin: 0 0 16px;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.55);
}
.shopfront-branding .color-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.shopfront-branding .color-row input[type=color] {
  width: 48px;
  height: 40px;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}
.shopfront-branding .hex-field {
  flex: 1;
}
.shopfront-branding .preview-swatch {
  height: 12px;
  border-radius: 999px;
  margin-bottom: 12px;
}
.shopfront-branding .preview-btn {
  border: none;
  border-radius: 8px;
  color: #fff;
  padding: 8px 14px;
  font-weight: 600;
  cursor: default;
}
.shopfront-branding .preview-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  overflow: hidden;
}
.shopfront-branding .branding-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}
.shopfront-branding .jumbo-field {
  grid-column: 1/-1;
  margin-bottom: 8px;
}
.shopfront-branding .jumbo-field > label {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}
.shopfront-branding .jumbo-field .hint {
  margin: 0 0 12px;
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.875rem;
}
.shopfront-branding .jumbo-field .full-width {
  width: 100%;
  margin-top: 8px;
}
.shopfront-branding .jumbo-preview {
  width: 100%;
  max-width: 520px;
  height: 140px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  border: 1px solid #e5e7eb;
  margin-bottom: 12px;
}
.shopfront-branding .promo-hero-preview {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 12px;
  align-items: center;
  width: 100%;
  max-width: 640px;
  min-height: 168px;
  padding: 16px 18px;
  margin-bottom: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
.shopfront-branding .promo-hero-preview__copy {
  min-width: 0;
}
.shopfront-branding .promo-hero-preview__copy .promo-hero-preview__eyebrow {
  display: block;
  font-size: 0.7rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(15, 23, 42, 0.45);
  margin-bottom: 4px;
}
.shopfront-branding .promo-hero-preview__copy strong {
  display: block;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.25;
  margin-bottom: 4px;
}
.shopfront-branding .promo-hero-preview__copy strong span {
  color: var(--brand-accent, #2563eb);
  font-weight: 600;
}
.shopfront-branding .promo-hero-preview__copy p {
  margin: 0;
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.62);
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.shopfront-branding .promo-hero-preview__side {
  min-width: 0;
}
.shopfront-branding .promo-hero-preview__empty {
  font-size: 0.8rem;
  color: rgba(15, 23, 42, 0.45);
  text-align: center;
  padding: 20px 8px;
  border: 1px dashed #d1d5db;
  border-radius: 8px;
}
.shopfront-branding .promo-blend--preview {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, #000 var(--promo-fade, 22%), #000 calc(100% - var(--promo-fade, 22%)), transparent 100%), linear-gradient(180deg, transparent 0%, #000 var(--promo-fade-y, 18%), #000 calc(100% - var(--promo-fade-y, 18%)), transparent 100%);
  -webkit-mask-composite: source-in;
  mask-image: linear-gradient(90deg, transparent 0%, #000 var(--promo-fade, 22%), #000 calc(100% - var(--promo-fade, 22%)), transparent 100%), linear-gradient(180deg, transparent 0%, #000 var(--promo-fade-y, 18%), #000 calc(100% - var(--promo-fade-y, 18%)), transparent 100%);
  mask-composite: intersect;
  opacity: var(--promo-blend-opacity, 0.92);
}
.shopfront-branding .promo-blend--preview img {
  display: block;
  width: 100%;
  height: 132px;
  object-fit: cover;
  object-position: center;
}
.shopfront-branding .blend-controls {
  display: grid;
  gap: 10px;
  max-width: 640px;
  margin-bottom: 12px;
}
.shopfront-branding .blend-control {
  display: grid;
  gap: 4px;
  font-size: 0.85rem;
  color: rgba(15, 23, 42, 0.72);
}
.shopfront-branding .blend-control strong {
  font-weight: 600;
  color: #0f172a;
}
.shopfront-branding .blend-control input[type=range] {
  width: 100%;
  accent-color: var(--brand-accent, #2563eb);
}
@media (max-width: 640px) {
  .shopfront-branding .promo-hero-preview {
    grid-template-columns: 1fr;
  }
}
.shopfront-branding .jumbo-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.shopfront-branding .section-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}
.shopfront-branding .section-toolbar button mat-icon {
  margin-right: 4px;
  font-size: 18px;
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.shopfront-branding .section-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.shopfront-branding .section-row {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto;
  gap: 4px 8px;
  align-items: center;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: #fafafa;
}
.shopfront-branding .section-row.section-disabled {
  opacity: 0.55;
}
.shopfront-branding .drag-handle {
  cursor: grab;
  color: rgba(0, 0, 0, 0.45);
}
.shopfront-branding .section-toggle,
.shopfront-branding .section-title {
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px;
  text-align: left;
}
.shopfront-branding .section-title {
  min-width: 0;
}
.shopfront-branding .section-title strong {
  font-size: 0.95rem;
}
.shopfront-branding .section-title .section-id {
  color: rgba(0, 0, 0, 0.45);
  font-size: 0.75rem;
}
.shopfront-branding .section-title mat-icon {
  margin-left: auto;
  color: rgba(0, 0, 0, 0.45);
}
.shopfront-branding .section-editor {
  grid-column: 1/-1;
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}
.shopfront-branding .cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  background: #fff;
}
.shopfront-branding .cdk-drag-placeholder {
  opacity: 0.35;
}

.form-check {
  margin-bottom: 10px;
}

.form-actions {
  margin-top: 30px;
}
.form-actions .btn {
  margin-right: 10px;
}
.form-actions .btn-primary {
  background: #d4af37;
  border-color: #d4af37;
}
.form-actions .btn-primary:hover {
  background: rgb(177.7777777778, 144.8888888889, 38.2222222222);
  border-color: rgb(177.7777777778, 144.8888888889, 38.2222222222);
}

/* Login Required */
.login-required {
  text-align: center;
  padding: 100px 0;
}
.login-required i {
  font-size: 64px;
  color: #d4af37;
  margin-bottom: 20px;
}
.login-required h2 {
  font-size: 24px;
  margin-bottom: 10px;
}
.login-required p {
  color: #666;
  margin-bottom: 20px;
}
.login-required .btn-primary {
  background: #d4af37;
  border-color: #d4af37;
}
.login-required .btn-primary:hover {
  background: rgb(177.7777777778, 144.8888888889, 38.2222222222);
  border-color: rgb(177.7777777778, 144.8888888889, 38.2222222222);
}

@media (max-width: 768px) {
  .profile-header {
    padding: 20px;
  }
  .profile-avatar {
    width: 100px;
    height: 100px;
  }
  .profile-info {
    padding-left: 0;
    margin-top: 20px;
    text-align: center;
  }
  .name-container {
    flex-direction: column;
    align-items: center;
  }
  .profile-name {
    margin-right: 0;
    margin-bottom: 10px;
  }
  .profile-stats {
    margin-top: 20px;
  }
  .profile-tab,
  .profile-tab:hover,
  .profile-tab:focus,
  .profile-tab:active,
  .profile-tab:focus-visible,
  .profile-tab.active {
    height: 38px;
    padding: 0 12px;
    font-size: 14px;
  }
}
.analytics-panel {
  padding: 8px 0 16px;
}

.analytics-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
}

.analytics-custom-range {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: flex-end;
}
.analytics-custom-range label {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #666;
  gap: 4px;
}
.analytics-custom-range input[type=date] {
  border: 1px solid rgba(212, 175, 55, 0.35);
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 13px;
  background: #fff;
}

.apply-btn {
  border: 1px solid rgba(212, 175, 55, 0.35);
  border-radius: 8px;
  height: 34px;
}

.period-label {
  font-size: 0.85rem;
  margin-bottom: 8px;
}

.analytics-range-error {
  color: #a94442;
  font-size: 0.85rem;
  margin-bottom: 8px;
}

.delta {
  font-size: 0.75rem;
  color: #777;
  margin-top: 2px;
}

.chart-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 8px;
}

.series-toggles {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 6px;
}

.series-btn {
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: #fff;
  color: #555;
  border-radius: 16px;
  height: 28px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
}
.series-btn.active {
  border-color: rgba(212, 175, 55, 0.6);
  background: rgba(212, 175, 55, 0.15);
  color: #333;
}
.series-btn:focus-visible {
  outline: 2px solid rgba(212, 175, 55, 0.45);
  outline-offset: -2px;
}

.analytics-day-toggle {
  display: inline-flex;
  border: 1px solid rgba(212, 175, 55, 0.35);
  border-radius: 8px;
  overflow: hidden;
}

.day-btn {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  background: #fff;
  color: #555;
  height: 34px;
  padding: 0 14px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1;
  cursor: pointer;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  transition: color 0.15s ease, background-color 0.15s ease;
}
.day-btn + .day-btn {
  border-left: 1px solid rgba(212, 175, 55, 0.35);
}
.day-btn:hover:not(.active) {
  background: rgba(212, 175, 55, 0.08);
}
.day-btn.active {
  background: #d4af37;
  color: #fff;
}
.day-btn:focus-visible {
  outline: 2px solid rgba(212, 175, 55, 0.45);
  outline-offset: -2px;
}

.analytics-summary {
  margin-bottom: 8px;
  row-gap: 8px;
}

.views-chart-section {
  margin-top: 24px;
}
.views-chart-section h4 {
  font-size: 1.1rem;
  margin-bottom: 4px;
}

.chart-hint {
  font-size: 0.85rem;
  margin-bottom: 12px;
}

.views-chart-wrap {
  position: relative;
  height: 300px;
  width: 100%;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 12px 8px 8px;
}

.listing-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.listing-metrics {
  font-size: 0.85rem;
  margin-top: 4px;
}

.listing-metrics-right {
  white-space: nowrap;
  font-size: 0.9rem;
}

.listing-period-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 0.8rem;
  margin-bottom: 10px;
}

.listing-performance-section,
.listing-drilldown {
  margin-top: 28px;
}

.listing-search {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 6px 10px;
  min-width: 180px;
  font-size: 13px;
}

.listing-table-wrap {
  overflow-x: auto;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  background: #fff;
}

.listing-perf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}
.listing-perf-table th, .listing-perf-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  white-space: nowrap;
}
.listing-perf-table th {
  cursor: pointer;
  font-weight: 600;
  background: rgba(212, 175, 55, 0.08);
  -webkit-user-select: none;
          user-select: none;
}
.listing-perf-table tbody tr {
  cursor: pointer;
}
.listing-perf-table tbody tr:hover, .listing-perf-table tbody tr.selected {
  background: rgba(212, 175, 55, 0.1);
}

.perf-name {
  font-weight: 500;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.perf-status {
  font-size: 0.75rem;
}

.listing-chart-wrap {
  margin-top: 12px;
}

.analytics-error {
  color: #a94442;
}`, "",{"version":3,"sources":["webpack://./src/app/profile/profile.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAKhB;EACE,eAAA;EACA,iGAAA;EACA,iBAAA;AAHF;;AAMA,mBAAA;AACA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,yCAAA;AAHF;;AAMA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AAHF;AAKE;EACE,mBAAA;EACA,YAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;AAJF;AAME;EACE,aAAA;AAJJ;AAOE;EACE,qBAAA;AALJ;AAQE;EACE,YAAA;EACA,oBAAA;AANJ;;AAUA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AARF;;AAWA;EACE,gDAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AARF;;AAWA;EACE,mCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AARF;AAUE;EACE,iBAAA;AARJ;;AAaE;EACE,kBAAA;EACA,WAAA;AAVJ;AAYI;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAVN;;AAeA;EACE,aAAA;EACA,6BAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;AAZF;;AAeA;EACE,kBAAA;AAZF;AAcE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAZJ;AAeE;EACE,eAAA;EACA,WAAA;AAbJ;;AAiBA,iFAAA;AACA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,yCAAA;AAdF;;AAiBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,gDAAA;AAdF;;AAiBA;EACE,SAAA;EACA,UAAA;AAdF;;AAiBA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,SAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,yDAAA;AAdF;AAgBE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;EACA,uBAAA;EACA,oBAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,cAAA;EACA,cAAA;AAfJ;AAkBE;EAEE,+BAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,oCAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;AAsBE;EACE,2CAAA;EACA,oBAAA;AApBJ;;AAwBA,iBAAA;AACA;EACE,mBAAA;EACA,iBAAA;AArBF;AAuBE;EACE,mBAAA;EACA,qBAAA;AArBJ;AAuBI;EACE,8DAtQe;EAuQf,gEAvQe;AAkPrB;AAwBI;EACE,iBAAA;AAtBN;;AA2BA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,6EAAA;EACA,YAAA;EACA,qCAAA;AAxBF;AA0BE;EACE,2BAAA;EACA,yCAAA;EACA,qCAAA;AAxBJ;;AA4BA;EACE,kBAAA;EACA,aAAA;AAzBF;AA2BE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzBJ;;AA6BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA1BF;AA4BE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA1BJ;AA6BE;EACE,gBAAA;EACA,YAAA;AA3BJ;AA6BI;EACE,mBAAA;AA3BN;AA8BI;EACE,mBAAA;AA5BN;AA+BI;EACE,mBAAA;AA7BN;AAgCI;EACE,mBAAA;AA9BN;AAkCE;EACE,mBAAA;EACA,YAAA;AAhCJ;AAmCE;EACE,mBAAA;EACA,YAAA;AAjCJ;;AAqCA;EACE,aAAA;AAlCF;;AAqCA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAlCF;;AAqCA;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAlCF;AAoCE;EACE,WAAA;AAlCJ;;AAsCA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,2BAAA;EACA,eAAA;EACA,QAAA;AAnCF;AAqCE;EACE,cAAA;EACA,SAAA;AAnCJ;AAqCI;EACE,iBAAA;AAnCN;AAuCE;EACE,cAAA;EACA,qBAAA;AArCJ;AAuCI;EACE,mBAAA;EACA,YAAA;AArCN;;AA0CA;EACE,kBAAA;EACA,eAAA;AAvCF;;AA0CA;EACE,gBAAA;EACA,cAAA;AAvCF;AAyCE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAvCJ;AA0CE;EACE,eAAA;EACA,mBAAA;AAxCJ;AA2CE;EACE,WAAA;EACA,mBAAA;AAzCJ;;AA6CA,gBAAA;AACA;EACE,eAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA8CE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;AA3CJ;AA8CE;EACE,cAAA;EACA,cAAA;EACA,eAAA;AA5CJ;AA+CE;EACE,WAAA;EACA,eAAA;AA7CJ;;AAiDA;EACE,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA9CF;AAgDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,eAAA;AA/CJ;AAkDE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAhDJ;AAmDE;EACE,WAAA;EACA,eAAA;AAjDJ;;AAqDA;EACE,WAAA;EACA,SAAA;AAlDF;;AAqDA,cAAA;AACA;EACE,eAAA;AAlDF;;AAqDA;EACE,mBAAA;AAlDF;AAoDE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,gDAAA;AAlDJ;AAqDE;EACE,WAAA;EACA,gBAAA;AAnDJ;;AAwDE;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,4CAAA;AArDJ;AAuDI;EACE,mBAAA;AArDN;AAyDE;EACE,gBAAA;EACA,WAAA;AAvDJ;AA0DE;EACE,WAAA;AAxDJ;;AA4DA,iBAAA;AACA;EACE,eAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;AA2DE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,gDAAA;AAzDJ;;AA6DA;EACE,mBAAA;AA1DF;AA4DE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AA1DJ;;AA8DA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;AA3DF;;AA8DA,uDAAA;AACA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AA3DF;AA6DE;EACE,mBAAA;AA3DJ;AA6DI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;AA3DN;AA8DI;EACE,SAAA;EACA,yBAAA;AA5DN;AAgEE;EACE,cAAA;AA9DJ;AAiEE;EACE,cAAA;AA/DJ;AAkEE;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,mBAAA;AAhEJ;AAmEE;EACE;IACE,0BAAA;EAjEJ;AACF;AAoEE;;EAEE,WAAA;AAlEJ;AAqEE;EACE,mBAAA;AAnEJ;AAsEE;EACE,aAAA;EACA,gDAAA;EACA,aAAA;AApEJ;AAsEI;EACE,iBAAA;AApEN;AAuEI;EACE,WAAA;AArEN;AAyEE;EACE;IACE,0BAAA;EAvEJ;AACF;AA0EE;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;AAxEJ;AA2EE;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAzEJ;AA4EE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,mBAAA;AA1EJ;AA6EE;EACE,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,aAAA;AA3EJ;AA6EI;EACE,eAAA;EACA,iBAAA;AA3EN;AA8EI;EACE,gBAAA;EACA,mBAAA;EACA,0BAAA;AA5EN;AAgFE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA9EJ;AAgFI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,qCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AA9EN;AAkFE;EACE,OAAA;AAhFJ;AAmFE;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;AAjFJ;AAoFE;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAlFJ;AAqFE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AAnFJ;AAsFE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;AApFJ;AAuFE;EACE,iBAAA;EACA,kBAAA;AArFJ;AAuFI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;AArFN;AAwFI;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;AAtFN;AAyFI;EACE,WAAA;EACA,eAAA;AAvFN;AA2FE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EACA,mBAAA;AAzFJ;AA4FE;EACE,aAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;AA1FJ;AA6FE;EACE,YAAA;AA3FJ;AA6FI;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;AA3FN;AA8FI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AA5FN;AA8FM;EACE,mCAAA;EACA,gBAAA;AA5FR;AAgGI;EACE,SAAA;EACA,iBAAA;EACA,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AA9FN;AAkGE;EACE,YAAA;AAhGJ;AAmGE;EACE,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;AAjGJ;AAoGE;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,yRACE;EAEF,iCAAA;EACA,iRACE;EAEF,yBAAA;EACA,yCAAA;AAtGJ;AAwGI;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;AAtGN;AA0GE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAxGJ;AA2GE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;AAzGJ;AA2GI;EACE,gBAAA;EACA,cAAA;AAzGN;AA4GI;EACE,WAAA;EACA,0CAAA;AA1GN;AA8GE;EACE;IACE,0BAAA;EA5GJ;AACF;AA+GE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AA7GJ;AAgHE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA9GJ;AAgHI;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AA9GN;AAkHE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAhHJ;AAmHE;EACE,aAAA;EACA,oDAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AAjHJ;AAmHI;EACE,aAAA;AAjHN;AAqHE;EACE,YAAA;EACA,0BAAA;AAnHJ;AAsHE;;EAEE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AApHJ;AAuHE;EACE,YAAA;AArHJ;AAuHI;EACE,kBAAA;AArHN;AAwHI;EACE,0BAAA;EACA,kBAAA;AAtHN;AAyHI;EACE,iBAAA;EACA,0BAAA;AAvHN;AA2HE;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;AAzHJ;AA4HE;EACE,sBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AA1HJ;AA6HE;EACE,aAAA;AA3HJ;;AA+HA;EACE,mBAAA;AA5HF;;AA+HA;EACE,gBAAA;AA5HF;AA8HE;EACE,kBAAA;AA5HJ;AA+HE;EACE,mBAAA;EACA,qBAAA;AA7HJ;AA+HI;EACE,8DAjhCe;EAkhCf,gEAlhCe;AAq5BrB;;AAkIA,mBAAA;AACA;EACE,kBAAA;EACA,gBAAA;AA/HF;AAiIE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AA/HJ;AAkIE;EACE,eAAA;EACA,mBAAA;AAhIJ;AAmIE;EACE,WAAA;EACA,mBAAA;AAjIJ;AAoIE;EACE,mBAAA;EACA,qBAAA;AAlIJ;AAoII;EACE,8DAjjCe;EAkjCf,gEAljCe;AAg7BrB;;AAuIA;EACE;IACE,aAAA;EApIF;EAuIA;IACE,YAAA;IACA,aAAA;EArIF;EAwIA;IACE,eAAA;IACA,gBAAA;IACA,kBAAA;EAtIF;EAyIA;IACE,sBAAA;IACA,mBAAA;EAvIF;EA0IA;IACE,eAAA;IACA,mBAAA;EAxIF;EA2IA;IACE,gBAAA;EAzIF;EA4IA;;;;;;IAME,YAAA;IACA,eAAA;IACA,eAAA;EA1IF;AACF;AA6IA;EACE,mBAAA;AA3IF;;AA8IA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AA3IF;;AA8IA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,qBAAA;AA3IF;AA6IE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;AA3IJ;AA8IE;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA5IJ;;AAgJA;EACE,0CAAA;EACA,kBAAA;EACA,YAAA;AA7IF;;AAgJA;EACE,kBAAA;EACA,kBAAA;AA7IF;;AAgJA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AA7IF;;AAgJA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AA7IF;;AAgJA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AA7IF;;AAgJA;EACE,oBAAA;EACA,eAAA;EACA,QAAA;AA7IF;;AAgJA;EACE,gBAAA;EACA,wBAAA;EACA,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,kFAAA;AA7IF;AA+IE;EACE,qCAAA;EACA,oCAAA;EACA,WAAA;AA7IJ;AAgJE;EACE,2CAAA;EACA,oBAAA;AA9IJ;;AAkJA;EACE,oBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AA/IF;;AAkJA;EACE,gBAAA;EACA,wBAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,yDAAA;AA/IF;AAiJE;EACE,+CAAA;AA/IJ;AAkJE;EACE,oCAAA;AAhJJ;AAmJE;EACE,mBAAA;EACA,WAAA;AAjJJ;AAoJE;EACE,2CAAA;EACA,oBAAA;AAlJJ;;AAsJA;EACE,kBAAA;EACA,YAAA;AAnJF;;AAsJA;EACE,gBAAA;AAnJF;AAqJE;EACE,iBAAA;EACA,kBAAA;AAnJJ;;AAuJA;EACE,kBAAA;EACA,mBAAA;AApJF;;AAuJA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,qBAAA;AApJF;;AAuJA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,4CAAA;AApJF;;AAuJA;EACE,kBAAA;EACA,eAAA;AApJF;;AAuJA;EACE,mBAAA;EACA,iBAAA;AApJF;;AAuJA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AApJF;;AAuJA;;EAEE,gBAAA;AApJF;;AAuJA;EACE,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AApJF;;AAuJA;EACE,gBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gBAAA;AApJF;;AAuJA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AApJF;AAsJE;EACE,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,mBAAA;AApJJ;AAuJE;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;UAAA,iBAAA;AArJJ;AAwJE;EACE,eAAA;AAtJJ;AAwJI;EAEE,mCAAA;AAvJN;;AA4JA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAzJF;;AA4JA;EACE,kBAAA;AAzJF;;AA4JA;EACE,gBAAA;AAzJF;;AA4JA;EACE,cAAA;AAzJF","sourcesContent":["@use 'sass:color';\n\n$profile-gold: #d4af37;\n$profile-gold-hover: color.adjust($profile-gold, $lightness: -10%);\n\n.profile-section {\n  padding: 60px 0;\n  background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,248,248,0.95) 100%);\n  min-height: 100vh;\n}\n\n/* Profile Header */\n.profile-header {\n  background: white;\n  border-radius: 16px;\n  padding: 30px;\n  margin-bottom: 30px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.05);\n  border: 1px solid rgba(212,175,55,0.1);\n}\n\n.profile-avatar {\n  position: relative;\n  width: 120px;\n  height: 120px;\n  margin: 0 auto;\n}\n\n.avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 3px solid #d4af37;\n  background: #f3f4f6;\n\n  &.avatar-img-svg {\n    object-fit: contain;\n    padding: 8px;\n  }\n}\n\n.avatar-edit {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 36px;\n  height: 36px;\n  background: #d4af37;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin: 0;\n\n  input {\n    display: none;\n  }\n\n  &:hover {\n    transform: scale(1.1);\n  }\n\n  &.avatar-edit-disabled {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n}\n\n.avatar-clear {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 50%;\n  background: #b91c1c;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0;\n\n  &:hover {\n    background: #991b1b;\n  }\n}\n\n.avatar-hint {\n  max-width: 140px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.profile-info {\n  padding-left: 20px;\n}\n\n.name-container {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.profile-name {\n  font-family: 'Helvetica Neue', Arial, sans-serif;\n  font-weight: 500;\n  font-size: 24px;\n  margin: 0;\n  margin-right: 10px;\n}\n\n.verified-badge {\n  background: rgba(212,175,55,0.1);\n  color: #d4af37;\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  \n  i {\n    margin-right: 5px;\n  }\n}\n\n.contact-info {\n  p {\n    margin-bottom: 5px;\n    color: #666;\n    \n    i {\n      color: #d4af37;\n      width: 20px;\n      margin-right: 8px;\n    }\n  }\n}\n\n.profile-stats {\n  display: flex;\n  justify-content: space-around;\n  background: rgba(212,175,55,0.05);\n  border-radius: 12px;\n  padding: 15px;\n}\n\n.stat-item {\n  text-align: center;\n  \n  .stat-value {\n    display: block;\n    font-size: 24px;\n    font-weight: 500;\n    color: #d4af37;\n  }\n  \n  .stat-label {\n    font-size: 14px;\n    color: #666;\n  }\n}\n\n/* Profile Tabs — custom classes (not Bootstrap nav-tabs) so borders don't jump */\n.profile-tabs {\n  background: white;\n  border-radius: 16px;\n  padding: 30px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.05);\n  border: 1px solid rgba(212,175,55,0.1);\n}\n\n.profile-tab-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  list-style: none;\n  margin: 0 0 30px;\n  padding: 0;\n  border-bottom: 1px solid rgba(212,175,55,0.2);\n}\n\n.profile-tab-item {\n  margin: 0;\n  padding: 0;\n}\n\n.profile-tab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 42px;\n  margin: 0;\n  padding: 0 20px;\n  border: 0;\n  border-radius: 8px 8px 0 0;\n  background: transparent;\n  color: #666 !important;\n  font: inherit;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 1;\n  text-decoration: none !important;\n  white-space: nowrap;\n  cursor: pointer;\n  outline: none;\n  box-shadow: none;\n  transition: color 0.15s ease, background-color 0.15s ease;\n\n  &::after {\n    content: '';\n    position: absolute;\n    left: 12px;\n    right: 12px;\n    bottom: 0;\n    height: 3px;\n    border-radius: 2px 2px 0 0;\n    background: transparent;\n    pointer-events: none;\n  }\n\n  i {\n    margin-right: 8px;\n    color: #d4af37;\n    flex-shrink: 0;\n  }\n\n  &:hover:not(.active),\n  &:focus:not(.active) {\n    background: rgba(0, 0, 0, 0.02);\n    color: #666 !important;\n  }\n\n  &.active {\n    color: #d4af37 !important;\n    background: rgba(212, 175, 55, 0.05);\n\n    &::after {\n      background: #d4af37;\n    }\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba(212, 175, 55, 0.45);\n    outline-offset: -2px;\n  }\n}\n\n/* Listings Tab */\n.add-listing-btn {\n  margin-bottom: 20px;\n  text-align: right;\n  \n  .btn-primary {\n    background: #d4af37;\n    border-color: #d4af37;\n    \n    &:hover {\n      background: $profile-gold-hover;\n      border-color: $profile-gold-hover;\n    }\n    \n    i {\n      margin-right: 8px;\n    }\n  }\n}\n\n.listing-card {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n  transition: box-shadow 0.3s ease, border-color 0.3s ease, transform 0.3s ease;\n  height: 100%;\n  border: 1px solid rgba(0,0,0,0.05);\n  \n  &:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 24px rgba(0,0,0,0.1);\n    border-color: rgba(212,175,55,0.3);\n  }\n}\n\n.listing-image {\n  position: relative;\n  height: 180px;\n  \n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.listing-badges {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  \n  .badge {\n    display: block;\n    margin-bottom: 5px;\n    padding: 5px 10px;\n    border-radius: 4px;\n    font-weight: 500;\n    font-size: 12px;\n  }\n  \n  .badge-status {\n    background: #666;\n    color: white;\n\n    &[data-status=\"PENDING\"] {\n      background: #c9a227;\n    }\n\n    &[data-status=\"REJECTED\"] {\n      background: #c62828;\n    }\n\n    &[data-status=\"PUBLISHED\"] {\n      background: #2e7d32;\n    }\n\n    &[data-status=\"DRAFT\"] {\n      background: #616161;\n    }\n  }\n  \n  .badge-featured {\n    background: #d4af37;\n    color: white;\n  }\n  \n  .badge-new {\n    background: #4CAF50;\n    color: white;\n  }\n}\n\n.listing-content {\n  padding: 15px;\n}\n\n.listing-flash {\n  margin: 0 0 16px;\n  padding: 10px 12px;\n  border-radius: 8px;\n}\n\n.listing-flash-ok {\n  background: #f1f8f2;\n  color: #0f5132;\n  border: 1px solid #b7dfc0;\n}\n\n.listing-flash-error {\n  background: #fff5f5;\n  color: #842029;\n  border: 1px solid #f5c2c7;\n}\n\n.listing-rejection {\n  font-size: 13px;\n  color: #842029;\n  margin: -8px 0 12px;\n\n  &.hint {\n    color: #666;\n  }\n}\n\n.listing-title {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #333;\n}\n\n.listing-price {\n  font-size: 18px;\n  font-weight: 600;\n  color: #d4af37;\n  margin-bottom: 15px;\n}\n\n.listing-actions {\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  gap: 8px;\n  \n  .btn {\n    flex: 0 0 auto;\n    margin: 0;\n    \n    i {\n      margin-right: 5px;\n    }\n  }\n  \n  .btn-outline-primary {\n    color: #d4af37;\n    border-color: #d4af37;\n    \n    &:hover {\n      background: #d4af37;\n      color: white;\n    }\n  }\n}\n\n.empty-state {\n  text-align: center;\n  padding: 50px 0;\n}\n\n.empty-state-content {\n  max-width: 400px;\n  margin: 0 auto;\n  \n  i {\n    font-size: 48px;\n    color: #d4af37;\n    margin-bottom: 20px;\n  }\n  \n  h3 {\n    font-size: 20px;\n    margin-bottom: 10px;\n  }\n  \n  p {\n    color: #666;\n    margin-bottom: 20px;\n  }\n}\n\n/* Reviews Tab */\n.reviews-container {\n  padding: 20px 0;\n}\n\n.review-summary {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.overall-rating {\n  .rating-value {\n    font-size: 48px;\n    font-weight: 600;\n    color: #d4af37;\n    display: block;\n    line-height: 1;\n  }\n  \n  .stars {\n    margin: 10px 0;\n    color: #d4af37;\n    font-size: 18px;\n  }\n  \n  .rating-count {\n    color: #666;\n    font-size: 14px;\n  }\n}\n\n.review-item {\n  background: rgba(255,255,255,0.5);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n  border: 1px solid rgba(0,0,0,0.05);\n}\n\n.reviewer-info {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n  \n  .reviewer-avatar {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    margin-right: 15px;\n  }\n  \n  h4 {\n    font-size: 16px;\n    margin: 0 0 5px;\n  }\n  \n  .stars {\n    color: #d4af37;\n    font-size: 14px;\n    margin-bottom: 5px;\n  }\n  \n  .review-date {\n    color: #999;\n    font-size: 12px;\n  }\n}\n\n.review-text {\n  color: #333;\n  margin: 0;\n}\n\n/* About Tab */\n.about-container {\n  padding: 20px 0;\n}\n\n.about-section {\n  margin-bottom: 30px;\n  \n  h3 {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 15px;\n    color: #333;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(212,175,55,0.2);\n  }\n  \n  p {\n    color: #666;\n    line-height: 1.6;\n  }\n}\n\n.business-hours {\n  .day-hours {\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 0;\n    border-bottom: 1px solid rgba(0,0,0,0.05);\n    \n    &:last-child {\n      border-bottom: none;\n    }\n  }\n  \n  .day {\n    font-weight: 500;\n    color: #333;\n  }\n  \n  .hours {\n    color: #666;\n  }\n}\n\n/* Settings Tab */\n.settings-container {\n  padding: 20px 0;\n}\n\n.form-section {\n  margin-bottom: 30px;\n  \n  h3 {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 20px;\n    color: #333;\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(212,175,55,0.2);\n  }\n}\n\n.form-group {\n  margin-bottom: 20px;\n  \n  label {\n    font-weight: 500;\n    color: #333;\n    margin-bottom: 8px;\n  }\n}\n\n.shop-jumbo-preview {\n  width: 100%;\n  max-width: 480px;\n  height: 120px;\n  border-radius: 8px;\n  background-size: cover;\n  background-position: center;\n  border: 1px solid #e5e7eb;\n}\n\n/* Shopfront editor — matches Admin → Branding layout */\n.shopfront-branding {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 8px 0 48px;\n\n  .branding-header {\n    margin-bottom: 24px;\n\n    h1 {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      margin: 0 0 8px;\n      font-size: 1.75rem;\n    }\n\n    p {\n      margin: 0;\n      color: rgba(0, 0, 0, 0.6);\n    }\n  }\n\n  .error-text {\n    color: #b91c1c;\n  }\n\n  .success-text {\n    color: #15803d;\n  }\n\n  .branding-identity {\n    display: grid;\n    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n    gap: 16px;\n    margin-bottom: 16px;\n  }\n\n  @media (max-width: 720px) {\n    .branding-identity {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .name-field,\n  .font-field {\n    width: 100%;\n  }\n\n  .home-card {\n    margin-bottom: 16px;\n  }\n\n  .home-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 8px 16px;\n\n    .full-width {\n      grid-column: 1 / -1;\n    }\n\n    mat-form-field {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 720px) {\n    .home-grid {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .identity-preview {\n    display: inline-flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 4px;\n    padding: 10px 14px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 10px;\n    background: #fafafa;\n  }\n\n  .preview-name {\n    font-size: 1.1rem;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    color: #1a1a1a;\n  }\n\n  .branding-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  .branding-card {\n    background: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    padding: 16px;\n\n    h2 {\n      margin: 0 0 4px;\n      font-size: 1.1rem;\n    }\n\n    .hint {\n      margin: 0 0 16px;\n      font-size: 0.875rem;\n      color: rgba(0, 0, 0, 0.55);\n    }\n  }\n\n  .color-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 12px;\n\n    input[type='color'] {\n      width: 48px;\n      height: 40px;\n      padding: 0;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      border-radius: 8px;\n      background: transparent;\n      cursor: pointer;\n    }\n  }\n\n  .hex-field {\n    flex: 1;\n  }\n\n  .preview-swatch {\n    height: 12px;\n    border-radius: 999px;\n    margin-bottom: 12px;\n  }\n\n  .preview-btn {\n    border: none;\n    border-radius: 8px;\n    color: #fff;\n    padding: 8px 14px;\n    font-weight: 600;\n    cursor: default;\n  }\n\n  .preview-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    color: #fff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    overflow: hidden;\n  }\n\n  .branding-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    justify-content: flex-end;\n  }\n\n  .jumbo-field {\n    grid-column: 1 / -1;\n    margin-bottom: 8px;\n\n    > label {\n      display: block;\n      font-weight: 600;\n      margin-bottom: 4px;\n    }\n\n    .hint {\n      margin: 0 0 12px;\n      color: rgba(0, 0, 0, 0.55);\n      font-size: 0.875rem;\n    }\n\n    .full-width {\n      width: 100%;\n      margin-top: 8px;\n    }\n  }\n\n  .jumbo-preview {\n    width: 100%;\n    max-width: 520px;\n    height: 140px;\n    border-radius: 8px;\n    background-size: cover;\n    background-position: center;\n    border: 1px solid #e5e7eb;\n    margin-bottom: 12px;\n  }\n\n  .promo-hero-preview {\n    display: grid;\n    grid-template-columns: 1.1fr 0.9fr;\n    gap: 12px;\n    align-items: center;\n    width: 100%;\n    max-width: 640px;\n    min-height: 168px;\n    padding: 16px 18px;\n    margin-bottom: 12px;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n    overflow: hidden;\n    background-size: cover;\n    background-position: center;\n  }\n\n  .promo-hero-preview__copy {\n    min-width: 0;\n\n    .promo-hero-preview__eyebrow {\n      display: block;\n      font-size: 0.7rem;\n      letter-spacing: 0.06em;\n      text-transform: uppercase;\n      color: rgba(15, 23, 42, 0.45);\n      margin-bottom: 4px;\n    }\n\n    strong {\n      display: block;\n      font-size: 1rem;\n      font-weight: 600;\n      color: #0f172a;\n      line-height: 1.25;\n      margin-bottom: 4px;\n\n      span {\n        color: var(--brand-accent, #2563eb);\n        font-weight: 600;\n      }\n    }\n\n    p {\n      margin: 0;\n      font-size: 0.8rem;\n      color: rgba(15, 23, 42, 0.62);\n      line-height: 1.35;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n\n  .promo-hero-preview__side {\n    min-width: 0;\n  }\n\n  .promo-hero-preview__empty {\n    font-size: 0.8rem;\n    color: rgba(15, 23, 42, 0.45);\n    text-align: center;\n    padding: 20px 8px;\n    border: 1px dashed #d1d5db;\n    border-radius: 8px;\n  }\n\n  .promo-blend--preview {\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    border: none;\n    background: transparent;\n    overflow: hidden;\n    -webkit-mask-image:\n      linear-gradient(90deg, transparent 0%, #000 var(--promo-fade, 22%), #000 calc(100% - var(--promo-fade, 22%)), transparent 100%),\n      linear-gradient(180deg, transparent 0%, #000 var(--promo-fade-y, 18%), #000 calc(100% - var(--promo-fade-y, 18%)), transparent 100%);\n    -webkit-mask-composite: source-in;\n    mask-image:\n      linear-gradient(90deg, transparent 0%, #000 var(--promo-fade, 22%), #000 calc(100% - var(--promo-fade, 22%)), transparent 100%),\n      linear-gradient(180deg, transparent 0%, #000 var(--promo-fade-y, 18%), #000 calc(100% - var(--promo-fade-y, 18%)), transparent 100%);\n    mask-composite: intersect;\n    opacity: var(--promo-blend-opacity, 0.92);\n\n    img {\n      display: block;\n      width: 100%;\n      height: 132px;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  .blend-controls {\n    display: grid;\n    gap: 10px;\n    max-width: 640px;\n    margin-bottom: 12px;\n  }\n\n  .blend-control {\n    display: grid;\n    gap: 4px;\n    font-size: 0.85rem;\n    color: rgba(15, 23, 42, 0.72);\n\n    strong {\n      font-weight: 600;\n      color: #0f172a;\n    }\n\n    input[type='range'] {\n      width: 100%;\n      accent-color: var(--brand-accent, #2563eb);\n    }\n  }\n\n  @media (max-width: 640px) {\n    .promo-hero-preview {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .jumbo-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 8px;\n  }\n\n  .section-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 12px;\n\n    button mat-icon {\n      margin-right: 4px;\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      vertical-align: middle;\n    }\n  }\n\n  .section-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .section-row {\n    display: grid;\n    grid-template-columns: auto auto minmax(0, 1fr) auto;\n    gap: 4px 8px;\n    align-items: center;\n    padding: 10px 12px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    background: #fafafa;\n\n    &.section-disabled {\n      opacity: 0.55;\n    }\n  }\n\n  .drag-handle {\n    cursor: grab;\n    color: rgba(0, 0, 0, 0.45);\n  }\n\n  .section-toggle,\n  .section-title {\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px;\n    text-align: left;\n  }\n\n  .section-title {\n    min-width: 0;\n\n    strong {\n      font-size: 0.95rem;\n    }\n\n    .section-id {\n      color: rgba(0, 0, 0, 0.45);\n      font-size: 0.75rem;\n    }\n\n    mat-icon {\n      margin-left: auto;\n      color: rgba(0, 0, 0, 0.45);\n    }\n  }\n\n  .section-editor {\n    grid-column: 1 / -1;\n    margin-top: 8px;\n    padding-top: 12px;\n    border-top: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  .cdk-drag-preview {\n    box-sizing: border-box;\n    border-radius: 10px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n    background: #fff;\n  }\n\n  .cdk-drag-placeholder {\n    opacity: 0.35;\n  }\n}\n\n.form-check {\n  margin-bottom: 10px;\n}\n\n.form-actions {\n  margin-top: 30px;\n  \n  .btn {\n    margin-right: 10px;\n  }\n  \n  .btn-primary {\n    background: #d4af37;\n    border-color: #d4af37;\n    \n    &:hover {\n      background: $profile-gold-hover;\n      border-color: $profile-gold-hover;\n    }\n  }\n}\n\n/* Login Required */\n.login-required {\n  text-align: center;\n  padding: 100px 0;\n  \n  i {\n    font-size: 64px;\n    color: #d4af37;\n    margin-bottom: 20px;\n  }\n  \n  h2 {\n    font-size: 24px;\n    margin-bottom: 10px;\n  }\n  \n  p {\n    color: #666;\n    margin-bottom: 20px;\n  }\n  \n  .btn-primary {\n    background: #d4af37;\n    border-color: #d4af37;\n    \n    &:hover {\n      background: $profile-gold-hover;\n      border-color: $profile-gold-hover;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-header {\n    padding: 20px;\n  }\n  \n  .profile-avatar {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .profile-info {\n    padding-left: 0;\n    margin-top: 20px;\n    text-align: center;\n  }\n  \n  .name-container {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .profile-name {\n    margin-right: 0;\n    margin-bottom: 10px;\n  }\n  \n  .profile-stats {\n    margin-top: 20px;\n  }\n  \n  .profile-tab,\n  .profile-tab:hover,\n  .profile-tab:focus,\n  .profile-tab:active,\n  .profile-tab:focus-visible,\n  .profile-tab.active {\n    height: 38px;\n    padding: 0 12px;\n    font-size: 14px;\n  }\n}\n\n.analytics-panel {\n  padding: 8px 0 16px;\n}\n\n.analytics-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.analytics-custom-range {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: flex-end;\n\n  label {\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n    color: #666;\n    gap: 4px;\n  }\n\n  input[type=\"date\"] {\n    border: 1px solid rgba(212, 175, 55, 0.35);\n    border-radius: 6px;\n    padding: 5px 8px;\n    font-size: 13px;\n    background: #fff;\n  }\n}\n\n.apply-btn {\n  border: 1px solid rgba(212, 175, 55, 0.35);\n  border-radius: 8px;\n  height: 34px;\n}\n\n.period-label {\n  font-size: 0.85rem;\n  margin-bottom: 8px;\n}\n\n.analytics-range-error {\n  color: #a94442;\n  font-size: 0.85rem;\n  margin-bottom: 8px;\n}\n\n.delta {\n  font-size: 0.75rem;\n  color: #777;\n  margin-top: 2px;\n}\n\n.chart-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.series-toggles {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.series-btn {\n  appearance: none;\n  -webkit-appearance: none;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  background: #fff;\n  color: #555;\n  border-radius: 16px;\n  height: 28px;\n  padding: 0 10px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  box-sizing: border-box;\n  box-shadow: none;\n  outline: none;\n  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;\n\n  &.active {\n    border-color: rgba(212, 175, 55, 0.6);\n    background: rgba(212, 175, 55, 0.15);\n    color: #333;\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba(212, 175, 55, 0.45);\n    outline-offset: -2px;\n  }\n}\n\n.analytics-day-toggle {\n  display: inline-flex;\n  border: 1px solid rgba(212, 175, 55, 0.35);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.day-btn {\n  appearance: none;\n  -webkit-appearance: none;\n  border: 0;\n  background: #fff;\n  color: #555;\n  height: 34px;\n  padding: 0 14px;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1;\n  cursor: pointer;\n  box-sizing: border-box;\n  box-shadow: none;\n  outline: none;\n  transition: color 0.15s ease, background-color 0.15s ease;\n\n  & + & {\n    border-left: 1px solid rgba(212, 175, 55, 0.35);\n  }\n\n  &:hover:not(.active) {\n    background: rgba(212, 175, 55, 0.08);\n  }\n\n  &.active {\n    background: #d4af37;\n    color: #fff;\n  }\n\n  &:focus-visible {\n    outline: 2px solid rgba(212, 175, 55, 0.45);\n    outline-offset: -2px;\n  }\n}\n\n.analytics-summary {\n  margin-bottom: 8px;\n  row-gap: 8px;\n}\n\n.views-chart-section {\n  margin-top: 24px;\n\n  h4 {\n    font-size: 1.1rem;\n    margin-bottom: 4px;\n  }\n}\n\n.chart-hint {\n  font-size: 0.85rem;\n  margin-bottom: 12px;\n}\n\n.views-chart-wrap {\n  position: relative;\n  height: 300px;\n  width: 100%;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n  padding: 12px 8px 8px;\n}\n\n.listing-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.listing-metrics {\n  font-size: 0.85rem;\n  margin-top: 4px;\n}\n\n.listing-metrics-right {\n  white-space: nowrap;\n  font-size: 0.9rem;\n}\n\n.listing-period-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 0.8rem;\n  margin-bottom: 10px;\n}\n\n.listing-performance-section,\n.listing-drilldown {\n  margin-top: 28px;\n}\n\n.listing-search {\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 8px;\n  padding: 6px 10px;\n  min-width: 180px;\n  font-size: 13px;\n}\n\n.listing-table-wrap {\n  overflow-x: auto;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-radius: 12px;\n  background: #fff;\n}\n\n.listing-perf-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n\n  th, td {\n    padding: 10px 12px;\n    text-align: left;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    white-space: nowrap;\n  }\n\n  th {\n    cursor: pointer;\n    font-weight: 600;\n    background: rgba(212, 175, 55, 0.08);\n    user-select: none;\n  }\n\n  tbody tr {\n    cursor: pointer;\n\n    &:hover,\n    &.selected {\n      background: rgba(212, 175, 55, 0.1);\n    }\n  }\n}\n\n.perf-name {\n  font-weight: 500;\n  max-width: 240px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.perf-status {\n  font-size: 0.75rem;\n}\n\n.listing-chart-wrap {\n  margin-top: 12px;\n}\n\n.analytics-error {\n  color: #a94442;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
